module.exports = __webpack_public_path__ + "static/img/gjt.a763e24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gjt.png
// module id = Gfok
// module chunks = 0